// Single Supabase client instance. Imports `.env` values via Vite. If the
// project URL or anon key are missing we return `null` from `getSupabase()` so
// the rest of the app can degrade gracefully to local-only mode.

import { createClient, SupabaseClient } from "@supabase/supabase-js";

const url     = import.meta.env.VITE_SUPABASE_URL  as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (client) return client;
  if (!url || !anonKey) return null;
  client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: "mittelalte.auth",
    },
  });
  return client;
}

export function isBackendConfigured(): boolean {
  return Boolean(url && anonKey);
}

/** Injected by vite.config.ts from package.json — see the note there. */
declare const __CLIENT_VER__: string;

export const CLIENT_VER = (import.meta.env.VITE_CLIENT_VER as string | undefined) ?? __CLIENT_VER__;
